import { Badge } from '@mantine/core';
import { STATUS } from '../lib/format';
import type { AssignmentStatus } from '../lib/types';

export function StatusBadge({ status, size = 'sm' }: { status: AssignmentStatus; size?: 'xs' | 'sm' | 'md' }) {
  const s = STATUS[status];
  return <Badge color={s.color} variant="light" size={size} style={{ flexShrink: 0, overflow: 'visible' }} styles={{ label: { overflow: 'visible' } }}>{s.label}</Badge>;
}
